import React from 'react';

interface RatingStructuredDataProps {
    name: string;
    description: string;
    ratingValue: number;
    reviewCount: number;
    bestRating?: number;
    worstRating?: number;
    url: string;
    image?: string;
}

const RatingStructuredData: React.FC<RatingStructuredDataProps> = ({
    name,
    description,
    ratingValue,
    reviewCount,
    bestRating = 5,
    worstRating = 1,
    url,
    image
}) => {
    const structuredData = {
        "@context": "https://schema.org/",
        "@type": "Product",
        "name": name,
        "description": description,
        "image": image,
        "brand": {
            "@type": "Brand",
            "name": "O Teu Dinheiro"
        },
        "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": ratingValue,
            "bestRating": bestRating,
            "worstRating": worstRating,
            "ratingCount": reviewCount,
            "reviewCount": reviewCount
        },
        "mainEntityOfPage": {
            "@type": "WebPage",
            "@id": url
        }
    };

    return (
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
        />
    );
};

export default RatingStructuredData;
